import React, { useState, useEffect } from 'react';
import { fetchAgentFileTypes, uploadAgentFile } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const UploadAgentFileModal = ({ agentId, onClose, onFileUploaded }) => {
    const [file, setFile] = useState(null);
    const [fileType, setFileType] = useState('');
    const [agentFileTypes, setAgentFileTypes] = useState({});
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const getFileTypes = async () => {
            try {
                const response = await fetchAgentFileTypes();
                setAgentFileTypes(response.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };
        getFileTypes();
    }, []);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!file || !fileType) {
            setError('Please fill in all fields.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('file_type', fileType);

        try {
            await uploadAgentFile(agentId, formData);
            setMessage('File uploaded successfully.');
            onFileUploaded();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Upload File</h2>
                {error && <p className="error">{error}</p>}
                {message && <p className="message">{message}</p>}
                <p>Allowed file types: pdf, jpg, png, heic. Max size: 2MB.</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <select value={fileType} onChange={(e) => setFileType(e.target.value)}>
                            <option value="">Select File Type</option>
                            {Object.entries(agentFileTypes).map(([id, name]) => (
                                <option key={id} value={id}>{name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <input type="file" onChange={handleFileChange} />
                    </div>
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                        <button type="submit" className="submit-button text-button">Upload</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UploadAgentFileModal;